import React, { useState } from "react";
import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import FiltersPartial from "./FiltersPartial.js";
import Modal from 'react-bootstrap/Modal';
import BatteryTransaction from "../../models/BatteryTransaction.js";
import { toast } from "react-toastify";

const Index = () => {
    const defaultHeaderConfig = { disableSort: false };
    const [filtersModel, setFiltersModel] = useState({});
    const [batteryTransactionDetails] = getApi('showbatteryTransactionDetails');
    const [showModal, setShowModal] = useState(false);
    const [batteryTransaction, setBatteryTransaction] = useState((new BatteryTransaction()).toStateJson());

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const headers = [
        {
            ...defaultHeaderConfig,
            label: 'ID',
            attr: 'id',
        },
        {
            ...defaultHeaderConfig,
            label: 'Voltup ID',
            value: (row) => {
                return row.rfid || "-"
            },
            disableSort: true
        },
        {
            ...defaultHeaderConfig,
            label: 'User',
            value: (row) => {
                if (row.user_id) {
                    return <div>
                        <span>{row.user_id}</span> <br/>
                        <span>{row.user_name}</span>
                    </div>
                }
                else {
                    return "-"
                }
            },
            disableSort: true
        },
        {
            ...defaultHeaderConfig,
            label: 'Status',
            value: (row) => {
                if (row.status == 0) {
                    return "Complete"
                }
                else if (row.status == 14) {
                    return "Incomplete"
                }
                else if (row.status == 15) {
                    return "Started"
                }
                else if (row.status == 16) {
                    return "Abandoned"
                }
                else {
                    return "-"
                }
            },
            disableSort: true
        },
        {
            ...defaultHeaderConfig,
            label: 'Expected Batteries',
            value: (row) => {
                if (row.expected_batteries.length !== 0) {
                    return row.expected_batteries.map((exBattery) => (<div key={exBattery}>{exBattery}</div>))
                }
                else {
                    return "-"
                }
            },
            disableSort: true
        },
        {
            ...defaultHeaderConfig,
            label: 'Swap Batteries',
            value: (row) => {
                if (row.swap_batteries_list.length !== 0) {
                    return row.swap_batteries_list.map((swBattery) => (<div key={swBattery}>{swBattery}</div>))
                }
                else {
                    return "-"
                }
            },
            disableSort: true
        },
        {
            ...defaultHeaderConfig,
            label: <span className="d-inline-flex">
                <span className="me-2">Swap Charge</span>
                <span className="mx-2">Discount</span>
                <span className="ms-2">Total Amount</span>
            </span>,
            value: (row) => {
                return <div className="d-flex justify-content-around">
                    <div>{row.swap_charge || 0}</div>
                    <div>{row.discount || 0}</div>
                    <div>{row.total_amount || 0}</div>
                </div>

            },
            disableSort: true
        },
        {
            ...defaultHeaderConfig,
            label: 'More Info',
            value: (row) => {
                return <div>
                    <button
                        type="button"
                        className="btn btn-sm font-size-11 text-success btn-outline-light"
                        onClick={(e) => getMoreDetails(row.id)}
                    >
                        More Details
                    </button>
                </div>
            },
            disableSort: true
        },
        {
            ...defaultHeaderConfig,
            label: 'Created At',
            attr: 'created_at',
        },
    ]

    const getMoreDetails = async (id) => {
        setBatteryTransaction({});
        try {
            const response = await batteryTransactionDetails({ id: id }).unwrap();
            setBatteryTransaction((new BatteryTransaction(response.data)).toStateJson());
            handleShow();
        } catch (error) {
            toast.error("Some Error Occured");
        }
    }

    return <div>
        <ListingPageComponent
            key={PAGES.BatteryTransactionsListingPage.name}
            uiPage={uiManager.getUiPage(PAGES.BatteryTransactionsListingPage.name)}
            breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Battery Transactions' }]}
            listingMutation={getApi('batteryTransactions')}
            className="battery-transactions-listing-page"
            contentHeading="Battery Transactions List - Results"
            headers={headers}
            recordsKey="battery_transactions"
            filtersModel={filtersModel}
            filters={
                <FiltersPartial
                    filtersModel={filtersModel}
                    setFiltersModel={setFiltersModel}
                />
            }
            searchBy={['ID', 'User ID']}
        />
        {/* // Modal // */}
        <Modal
            show={showModal}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            scrollable={true}
        >
            <Modal.Header
                style={{ backgroundImage: 'linear-gradient(103deg, #49c12b 0, #197800 99%)' }}
                className="text-white"
                closeButton
            >
                <Modal.Title>Battery Transaction Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {batteryTransaction.swap_items &&
                    <>
                        <h6 className="text-success">Swap Items :</h6>
                        <div className="container mt-4">
                            <h6 className="opacity-75">Battery 1</h6>
                            <table className="table table-bordered">
                                <thead className="thead-light">
                                    <tr>
                                        <th colSpan="2">In</th>
                                        <th colSpan="2">Out</th>
                                    </tr>
                                    <tr>
                                        <th className="opacity-75">ID</th>
                                        <th className="opacity-75">Serial Number</th>
                                        <th className="opacity-75">ID</th>
                                        <th className="opacity-75">Serial Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td rowSpan="2" className="fw-light">{batteryTransaction.battery_one_in_id || '-'}</td>
                                        <td rowSpan="2" className="fw-light">{batteryTransaction.battery_one_in_serial_number || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td rowSpan="2" className="fw-light">{batteryTransaction.battery_one_out_id || '-'}</td>
                                        <td rowSpan="2" className="fw-light">{batteryTransaction.battery_one_out_serial_number || '-'}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h6 className="opacity-75">Battery 2</h6>
                            <table className="table table-bordered">
                                <thead className="thead-light">
                                    <tr>
                                        <th colSpan="2">In</th>
                                        <th colSpan="2">Out</th>
                                    </tr>
                                    <tr>
                                        <th className="opacity-75">ID</th>
                                        <th className="opacity-75">Serial Number</th>
                                        <th className="opacity-75">ID</th>
                                        <th className="opacity-75">Serial Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td rowSpan="2" className="fw-light">{batteryTransaction.battery_two_in_id || '-'}</td>
                                        <td rowSpan="2" className="fw-light">{batteryTransaction.battery_two_in_serial_number || '-'}</td>
                                    </tr>
                                    <tr>
                                        <td rowSpan="2" className="fw-light">{batteryTransaction.battery_two_out_id || '-'}</td>
                                        <td rowSpan="2" className="fw-light">{batteryTransaction.battery_two_out_serial_number || '-'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </>
                }
                <h6 className="text-success pt-4">Battery Swap :</h6>
                <span className="row pt-3">
                    <span className="col-md-6 mb-1" style={{ fontWeight: 'bold' }}>ID</span>
                    <span className="col-md-6">: {batteryTransaction.battery_swap_id || "-"}</span>
                </span>
                <span className="row">
                    <span className="col-md-6 mb-1" style={{ fontWeight: 'bold' }}>Charging Station ID</span>
                    <span className="col-md-6">: {batteryTransaction.battery_swap_charging_station_id || "-"}</span>
                </span>
                <span className="row">
                    <span className="col-md-6 mb-1" style={{ fontWeight: 'bold' }}>Charging Station Owner</span>
                    <span className="col-md-6">: {batteryTransaction.battery_swap_charging_station_owner || "-"}</span>
                </span>   <span className="row">
                    <span className="col-md-6 mb-1" style={{ fontWeight: 'bold' }}>Status</span>
                    <span className="col-md-6">: {batteryTransaction.battery_swap_status || "-"}</span>
                </span>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-voltup-theme" onClick={handleClose}>
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    </div>
};

export default Index;
